/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.UploadBatchFileDetailseResponse,
  GetUpload: (params: vp.UploadBatchFileDetailsRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchUploadedFiles: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldGetUpload, setShouldGetUpload] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.UploadBatchFileDetailsRequest>({
    BatchTransactionRequestID: 0,
  });
  const [response, setResponse] = useState<vp.UploadBatchFileDetailseResponse>({
    Success: false,
    ErrorMessage: '',
    BatchDetails: {},
  });

  useEffect(() => {
    if (!shouldGetUpload) return () => {};

    const PostBulkCollection = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.fetchUploadedFileDetails(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldGetUpload) void PostBulkCollection();
    setShouldGetUpload(false);
    return () => {
      source.cancel();
    };
  }, [shouldGetUpload]);

  return [
    response,
    (_params: vp.UploadBatchFileDetailsRequest) => {
      setParams(_params);
      setShouldGetUpload(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        BatchDetails: {},
      });
      setShouldGetUpload(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchUploadedFiles);
